<template>
  <div class="csvUploader">
    <p>
      <strong>UPLOAD</strong> the completed file with all billing and payment details per {{sitePrefix}}.
    </p>

    <div class="form-group">
      <input type="file" name="csv_upload" class="form-control form-control-sm" placeholder="Select CSV" accept="text/csv" />
    </div>

    <p align="center"><button type="submit" class="btn btn-sm btn-success">Upload completed CSV</button></p>

    <div v-if="dataId">
      <div class="form-group">
        <label v-if="csvIsProcessing">Your CSV is being processed</label>
        <label v-else>Your CSV has been processed</label>

        <div class="progress">
          <!-- Success -->
          <div
            class="progress-bar bg-success"
            role="progressbar"
            aria-valuemin="0" aria-valuemax="100"
            :aria-valuenow="(this.successPct * 100)"
            :style="{ width: (this.successPct * 100) + '%' }"
          >
          </div>

          <!-- Failure -->
          <div
            class="progress-bar  bg-danger"
            role="progressbar"
            aria-valuemin="0" aria-valuemax="100"
            :aria-valuenow="(this.failurePct * 100)"
            :style="{ width: (this.failurePct * 100) + '%' }"
          >
          </div>
        </div>
      </div>

      <!-- List failures -->
      <p v-if="(failures.length > 0)">Please review the issues below</p>
      <ul class="list-group list-group-flush" v-if="(failures.length > 0)">
        <li class="list-group-item list-group-item-danger" v-for="failure in failures" :key="failure.id">
          <small>{{failure.data['Site Name']}} - {{failure.failureMessage}}</small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountId: String,
    dataId: Number,
    sitePrefix: { type: String, default: 'site' },
  },
  data: function() {
    return {
      failures: [],
      itemCount: false,
      processComplete: false,
      progress: 0,
      successPct: 0,
      failurePct: 0,
    };
  },
  computed: {
    csvIsProcessing: function() { return (this.dataId && (this.progress < 1)) ? true : false; },
    hasFailures: function() { return (this.failures.length > 0) ? true : false; },
    hasFile: function() { return (this.dataId) ? true : false },
    isSuccess: function() { return (this.successPct >= 1) ? true : false; },
  },
  methods: {
    checkStatus: function() {
      if(this.dataId && this.accountId) {
        // console.log('Checking status for data: ' + this.dataId);
        axios.get('/api/v1/account/' + this.accountId + '/data/' + this.dataId)
          .then(function(response) {
            // console.log(response.data.data);

            this.itemCount  = response.data.data.items.length;
            this.progress   = response.data.data.progress;
            
            this.successPct = response.data.data.success_pct;
            this.failurePct = response.data.data.failure_pct;

            this.failures = response.data.data.failures;
          }.bind(this))
          .catch(function(error) { console.error(error); }.bind(this))
          .finally(function() { /* TODO */ }.bind(this));
      }
    },
  },
  watch: {
    successPct: function() {
      if(this.successPct >= 1) { this.$root.displayNextButton = true; }
    },
  },
  mounted: function() {
    console.log('CSV uploader mounted');

    this.$root.displayNextButton = false;

    if(!this.accountId) { console.warn('No account code was passed'); }

    setInterval(function(){ this.checkStatus(); }.bind(this), 3000);
    if(this.dataId && this.accountId) { this.checkStatus(); }
  }
}
</script>